import { useEffect, useRef, useState, useContext, createContext } from 'react';
import styles from './AuthenticationDialog.module.css';
import { useOnClickOutside, SignUpProps } from './Authentication.hooks';

export const SignUpCognito = (args: SignUpProps) => {
	const [mode, setMode] = useState<Mode>('signup');
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [code, setCode] = useState('');
	return (
		<SignUpContext.Provider
			value={{
				mode,
				setMode,
				email,
				setEmail,
				password,
				setPassword,
				code,
				setCode,
			}}
		>
			{mode === 'signup' ? <SignUp {...args} /> : <Confirm {...args} />}
		</SignUpContext.Provider>
	);
};

export const SignUp = ({
	onClickLogIn,
	onCloseDialog,
	onSuccess,
}: SignUpProps) => {
	const { email, setEmail, password, setPassword, setMode } =
		useContext(SignUpContext);
	const ref = useRef(null);
	useOnClickOutside(ref, () => {
		onCloseDialog();
	});
	const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		try {
			setMode('confirm');
		} catch (e: any) {
			alert(e.message);
		}

		// onSuccess();
	};
	return (
		<form ref={ref} onSubmit={onSubmit}>
			<div className={styles['details']}>
				<h3>Create an account</h3>
				<h4>Start right now with us</h4>
				<div className={styles['input-control']}>
					<label htmlFor="email-input">Email</label>
					<input
						type="email"
						id="email-input"
						name="email"
						value={email}
						onChange={(e) => {
							setEmail(e.target.value);
						}}
						required
					/>
				</div>
				<div className={styles['input-control']}>
					<label htmlFor="password-input">Password</label>
					<input
						minLength={8}
						type="password"
						id="password-input"
						name="password"
						value={password}
						onChange={(e) => {
							setPassword(e.target.value);
						}}
						required
					/>
				</div>
			</div>
			<div className={styles['control']}>
				<button>Sign Up</button>
				<div>
					<p>Already have an account?</p>
					<button onClick={onClickLogIn}>Sign In</button>
				</div>
			</div>
		</form>
	);
};

export const Confirm = ({ onCloseDialog, onSuccess }: SignUpProps) => {
	const { email, code, setCode } = useContext(SignUpContext);
	const ref = useRef(null);
	useOnClickOutside(ref, () => {
		onCloseDialog();
	});
	const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		console.log(`The user register propertly`);
		onSuccess();
	};
	return (
		<form ref={ref} onSubmit={onSubmit}>
			<div className={styles['details']}>
				<h3>Confirmation code</h3>
				<h4>Start right now with us</h4>
				<div className={styles['input-control']}>
					<label htmlFor="code-input">Confirmation Code</label>
					<input
						type="number"
						minLength={6}
						maxLength={6}
						id="code-input"
						name="code"
						value={code}
						onChange={(e) => {
							setCode(e.target.value);
						}}
						required
					/>
				</div>
			</div>
			<div className={styles['control']}>
				<button>Confirm</button>
			</div>
		</form>
	);
};

export const SignUpContext = createContext<SignUpContextProps>({
	mode: 'signup',
	setMode: () => {},
	email: '',
	setEmail: () => {},
	password: '',
	setPassword: () => {},
	code: '',
	setCode: () => {},
});

interface SignUpContextProps {
	mode: Mode;
	setMode: (e: Mode) => void;
	email: string;
	setEmail: (e: string) => void;
	password: string;
	setPassword: (e: string) => void;
	code: string;
	setCode: (e: string) => void;
}

type Mode = 'signup' | 'confirm';
